<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="detail-header">
          <span class="header-title">灯光自动控制策略配置</span>
          <div class="arrow-pic"></div>
        </div>
        <el-divider></el-divider>
        <div class="config-header">
          <div class="config-header-title">将策略应用于以下组</div>
          <div class="config-content">
            <el-checkbox-group v-model="checkList">
              <el-checkbox
                :key="item.id"
                v-for="item in groubTabs"
                :label="item.areaCode"
                disabled
                >{{ item.areaName }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </div>

        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main style="padding-top: 0; overflow-y: auto">
        <div class="config-header">
          <div class="config-header-title">自动控制策略</div>
          <div class="config-content">
            <el-form
              ref="form"
              :model="data"
              :rules="rules"
              label-width="16rem"
              style="width: 80%"
            >
              <el-form-item label="自动控制关闭后" prop="autoCheck">
                <el-checkbox-group
                  v-model="data.autoCheck"
                  @change="changeCheck"
                  :disabled="isDisableControl"
                >
                  <el-checkbox
                    :key="item.id"
                    v-for="item in dict.type.light_auto_control"
                    :label="item.value"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>

              <div class="config-header-title">
                <el-checkbox
                  v-model="controlTypeCheck1"
                  @change="changeControlType1"
                  :disabled="isDisableControl"
                  >定时开关</el-checkbox
                >
              </div>
              <el-row v-if="controlTypeCheck1">
                <el-col :span="12">
                  <el-form-item label="打开时间" prop="openTime">
                    <el-time-picker
                      v-model="data.openTime"
                      format="HH:mm"
                      value-format="HH:mm"
                      :disabled="isDisableControl"
                    >
                    </el-time-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="关闭时间" prop="closeTime">
                    <el-time-picker
                      v-model="data.closeTime"
                      format="HH:mm"
                      value-format="HH:mm"
                      :disabled="isDisableControl"
                    >
                    </el-time-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="config-header-title">
                <el-checkbox
                  v-model="controlTypeCheck2"
                  @change="changeControlType2"
                  :disabled="isDisableControl"
                  >客流感应</el-checkbox
                >
              </div>
              <el-row v-if="controlTypeCheck2">
                <el-col :span="12">
                  <el-form-item label="开灯阈值" prop="openPassengerFlow">
                    <el-input-number
                      v-model="data.openPassengerFlow"
                      :disabled="isDisableControl"
                      :min="0"
                    ></el-input-number
                    ><span class="unitfont">人</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="关灯阈值" prop="closePassengerFlow">
                    <el-input-number
                      v-model="data.closePassengerFlow"
                      :disabled="isDisableControl"
                      :min="0"
                    ></el-input-number
                    ><span class="unitfont">人</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="controlTypeCheck2">
                <el-col :span="12">
                  <el-form-item label="开灯延时" prop="openDelay">
                    <el-input-number
                      v-model="data.openDelay"
                      :disabled="isDisableControl"
                      :min="0"
                    ></el-input-number
                    ><span class="unitfont">分钟</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="关灯延时" prop="closeDelay">
                    <el-input-number
                      v-model="data.closeDelay"
                      :disabled="isDisableControl"
                      :min="0"
                    ></el-input-number
                    ><span class="unitfont">分钟</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </zj-layout-main>
      <el-footer style="text-align: center">
        <el-button
          type="primary"
          @click="OnConfirm('form')"
          :disabled="isDisableControl"
          >确认</el-button
        >
        <el-button @click="OnCancel">取消</el-button>
      </el-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import {
  getEquipmentCode,
  listEquipment,
  listEquipmentArea,
} from "@/api/src/equipment";
import {
  listSmartLightSetting,
  addSmartLightSetting,
  updateSmartLightSetting,
} from "@/api/src/smartLightSetting";

export default {
  name: "LightControlConfig",
  controller: "UI",
  action: "LightControlConfig",
  dicts: ["light_auto_control"],
  data() {
    return {
      groubTabs: [{ areaName: "全部", areaCode: "0", id: "0" }],
      groupTabsValue: "all",
      //设备信息
      lightAllList: [],
      value: true,
      selectAreaCode: null,
      checkList: [],
      data: {
        autoCheck: ["1"],
        openTime: null,
        closeTime: null,
        openPassengerFlow: 0,
        closePassengerFlow: 0,
        openDelay: 0,
        closeDelay: 0,
      },
      rules: {
        autoCheck: [
          {
            required: true,
            message: "请选择自动控制关闭后配置",
          },
        ],

        openTime: [
          {
            required: true,
            message: "请填写打开时间",
          },
        ],
        closeTime: [
          {
            required: true,
            message: "请填写关闭时间",
          },
        ],
        openPassengerFlow: [
          {
            required: true,
            message: "请填写开灯阈值",
          },
        ],
        closePassengerFlow: [
          {
            required: true,
            message: "请填写关灯阈值",
          },
        ],
        openDelay: [
          {
            required: true,
            message: "请填写开灯延时",
          },
        ],
        closeDelay: [
          {
            required: true,
            message: "请填写关灯延时",
          },
        ],
      },
      isDisable: false, //防止重复提交
      controlTypeCheck1: false, //控制类型1 自动控制 2 客流感应
      controlTypeCheck2: false, //控制类型1 自动控制 2 客流感应
      isDisableControl: this.$route.query.isDisableControl,
    };
  },
  created: function () {
    this.checkList.push(this.$route.query.areaCode);
    //   this.data = this.RegionInfo;
    // alert(1);
    this.initTab();
    this.init();
  },
  mounted: function () {
    // alert(2);
    // this.init();
    // this.$nextTick(() => {
    //   this.init();
    // });
  },

  methods: {
    // 初始化
    initTab() {
      getEquipmentCode("lightEquipment").then((response) => {
        this.code = response.data;
        listEquipmentArea({ categoryCode: this.code, pageSize: 100 }).then(
          (response) => {
            this.groubTabs = [{ areaName: "全部", areaCode: "0", id: "0" }];
            response.data.forEach((element) => {
              this.groubTabs.push(element);
            });

            // this.getList();
          }
        );
      });
    },
    // 获取设备code
    init() {
      this.loading = true;

      listSmartLightSetting({
        areaCode: this.$route.query.areaCode,
        pageSize: 100,
      }).then((response) => {
        if (response.rows.length > 0) {
          // this.data = response.rows[0];
          let autoControl = response.rows[0].autoControl;
          this.data.autoCheck = [];
          this.data.autoCheck.push(autoControl);

          this.data = Object.assign(this.data, response.rows[0]);
          if (this.data.controlType === "1") {
            this.controlTypeCheck1 = true;
            this.controlTypeCheck2 = false;
          } else {
            this.controlTypeCheck1 = false;
            this.controlTypeCheck2 = true;
          }
          // this.data.openTime = response.rows[0].openTime;
          //this.data.autoCheck.push(this.data.autoControl);
        }

        this.loading = false;
      });
    },
    // 查询
    handleClick(tab, event) {
      this.selectAreaCode = tab.name;
    },
    OnCancel() {
      // Bus.$emit("backLightPanel", this.$route.query.areaCode);
      // this.$router.go(-1); //返回上一层
      this.$router.push({
        path: "/plugin/light/UI/LightControl",
        query: {
          areaCode: this.$route.query.areaCode,
        },
      });
    },
    changeCheck(val) {
      if (this.data.autoCheck.length > 1) {
        this.data.autoCheck.splice(0, 1);
      }
    },
    OnConfirm(formName) {
      this.isDisable = true;
      const that = this;
      if (
        this.controlTypeCheck1 &&
        !this.compareTime(this.data.openTime, this.data.closeTime)
      ) {
        that.$message({
          type: "error",
          message: "打开时间不能晚于关闭时间",
        });
        return;
      }
      if (
        this.controlTypeCheck2 &&
        this.data.openPassengerFlow &&
        this.data.openPassengerFlow == this.data.closePassengerFlow
      ) {
        that.$message({
          type: "error",
          message: "开灯阈值和关灯阈值不能相同",
        });
        return;
      }
      if (!that.controlTypeCheck1 && !that.controlTypeCheck2) {
        this.isDisable = false;
        that.$message({
          type: "warning",
          message: "请选择定时开关或者客流感应进行配置",
        });
        return;
      } else {
        that.data.controlType = that.controlTypeCheck1 ? "1" : "2";
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //  this.data.closeTime = Date.parse(this.data.closeTime);
          //  this.data.openTime = Date.parse(this.data.openTime);
          this.data.areaCode = this.$route.query.areaCode;
          this.data.autoControl = this.data.autoCheck[0] || null;
          this.data.status = this.$route.query.autoControl ? "1" : "2";
          if (this.data.id != null) {
            updateSmartLightSetting(this.data)
              .then((response) => {
                this.isDisable = false;

                this.$message({
                  type: "success",
                  message: "修改成功",
                });
                this.OnCancel();
              })
              .catch((err) => {
                this.isDisable = false;
              });
          } else {
            addSmartLightSetting(this.data)
              .then((response) => {
                this.isDisable = false;
                this.$message({
                  type: "success",
                  message: "增加成功",
                });
                this.OnCancel();
              })
              .catch((err) => {
                this.isDisable = false;
              });
          }
        } else {
          this.isDisable = false;
          return false;
        }
      });
    },
    changeControlType1(val) {
      if (val) {
        this.controlTypeCheck2 = false;
      }
    },
    changeControlType2(val) {
      if (val) {
        this.controlTypeCheck1 = false;
      }
    },

    //如果time2大于time1 返回true 否则 返回false
    compareTime(time1, time2) {
      if (this.time_to_sec(time2) - this.time_to_sec(time1) > 0) {
        return true;
      }
      return false;
    },

    //将时分转为时间戳
    time_to_sec(time) {
      if (time !== null) {
        var s = "";
        var hour = time.split(":")[0];
        var min = time.split(":")[1];

        s = Number(hour * 3600) + Number(min * 60);
        return s;
      }
    },
  },
};
</script>

<style lang="css" scoped>
</style>>


